export default __webpack_public_path__ + "static/media/rajon.ab284244.png";